export const adminInstallSeenKey = "chamakpatti-pwa-install-seen:admin";
export const adminInstalledKey = "chamakpatti-pwa-installed:admin";
export const adminInstallDismissalKey = "chamakpatti-pwa-install-dismissed:admin";

type InstallStorage = Pick<Storage, "getItem" | "setItem">;

export function hasSuppressedAdminInstall(storage: InstallStorage) {
  return [adminInstallSeenKey, adminInstalledKey, adminInstallDismissalKey]
    .some((key) => storage.getItem(key) === "1");
}

export function rememberAdminInstallShown(storage: InstallStorage) {
  storage.setItem(adminInstallSeenKey, "1");
}

export function rememberAdminInstalled(storage: InstallStorage) {
  rememberAdminInstallShown(storage);
  storage.setItem(adminInstalledKey, "1");
}

export function shouldShowAdminInstall({
  admin,
  installed,
  suppressed,
  nativePrompt,
  ios,
}: {
  admin: boolean;
  installed: boolean;
  suppressed: boolean;
  nativePrompt: boolean;
  ios: boolean;
}) {
  return admin && !installed && !suppressed && (nativePrompt || ios);
}
